<template>
<div class="chapter">
<div class="inner_page">
<p class="aut-int">All the persons and events in this book are entirely imaginary. Nothing in it derlves from anything which ever happened.</p>
<p class="aut-ded">Author’s dedication—</p>
<p class="aut-ded">To my favorite detective,</p>
<p class="aut-ded">CARL BRANDT</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Ded.vue?53bbaa7e